/* eslint-disable import/no-named-default */
export const getCustomConfigs = ({ t }) => {
    return []
    // return [
    //     { id: "vehicleTypes", display: t("vehicleTypes"), entryUrl: "vehicleTypes", pathKeywords: ["vehicleTypes"] },
    //     // { id: "iSMSWhatsapp", display: t("Whatsapp"), entryUrl: "iSMSWhatsapp", pathKeywords: ["iSMSWhatsapp"] },
    // ]
}

export const getCustomTranslations = () => {
    return []
    // return ["_@setting"]
}